const menu = {
    label: 'Atendimentos',
    icon: 'pi pi-fw pi-comments',
    to: '/expressos/atendimentos',
    rules: ['EXPR-ATEN-00'],
};

export default menu;
